import { SxProps, Theme } from '@mui/material';

export const InfoBubbleContentSx: SxProps<Theme> = {
  borderRadius: '999px',
  px: 2,
  py: 0.5,
  bgcolor: 'grey.800',
  color: 'common.white',
  fontSize: '0.85rem',
  minWidth: 'unset',
};
